import { z } from 'zod';
import type { ILocation, IServiceArea } from '../common';

interface IIndustry {
	categoryId?: string;
	entityType?: string;
	id?: string;
	industryId?: string;
	industryIds: string[];
	name: string;
	parentId?: string | null;
}

interface IBrand {
	description: string;
	industry: IIndustry;
	keywords: string[];
	logo: string;
	logoSquare?: string;
	logoLandscape?: string;
	logoSquareLight?: string;
	logoSquareDark?: string;
	logoLandscapeLight?: string;
	logoLandscapeDark?: string;
	name: string;
	url: string;
	phone_number?: string;
	locations?: ILocation[];
	serviceable_areas?: IServiceArea[] | null;
}

export interface IGetDomainDataSchema {
	catalogsExecution?: string | null;
	catalogsFound: number;
	deduceTonesAudiencesExecution?: string | null;
	description: string;
	keywords: string[];
	pageType?: string;
	title?: string;
	url: string;
	brand: IBrand;
}

export const IndustrySchema = z.object({
	categoryId: z.string(),
	entityType: z.string().optional(),
	id: z.string().optional(),
	industryId: z.string().optional(),
	industryIds: z.array(z.string()),
	name: z.string(),
	parentId: z.string().nullable().optional(),
});

const AddressSchema = z.object({
	street: z.string(),
	city: z.string(),
	state: z.string(),
	postalCode: z.string(),
	country: z.string(),
	lat: z.number(),
	long: z.number(),
	placeId: z.string().optional(),
});

const LocationSchema = z.object({
	name: z.string(),
	address: AddressSchema,
	main: z.boolean().optional(),
	phone_number: z.string().optional(),
});

const ServiceAreaSchema = z.object({
	name: z.string(),
	address: AddressSchema,
	radius: z.number(),
});

const BrandSchema = z.object({
	description: z.string(),
	industry: IndustrySchema,
	keywords: z.array(z.string()),
	logo: z.string(),
	logoSquare: z.string().optional(),
	logoLandscape: z.string().optional(),
	logoSquareLight: z.string().optional(),
	logoSquareDark: z.string().optional(),
	logoLandscapeLight: z.string().optional(),
	logoLandscapeDark: z.string().optional(),
	name: z.string(),
	url: z.string(),
	phone_number: z.string().optional(),
	locations: z.array(LocationSchema).optional(),
	serviceable_areas: z.array(ServiceAreaSchema).optional(),
});

export const GetDomainDataSchema: z.ZodType<IGetDomainDataSchema> = z.object({
	catalogsExecution: z.string().nullable().optional(),
	catalogsFound: z.number(),
	deduceTonesAudiencesExecution: z.string().nullable().optional(),
	description: z.string(),
	keywords: z.array(z.string()),
	pageType: z.string().optional(),
	title: z.string().optional(),
	url: z.string(),
	brand: BrandSchema,
});
